import React, { useEffect, useState } from "react";
import axios from "axios";
import LightGallery from "lightgallery/react";
import { useTranslation } from "react-i18next";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import lgZoom from "lightgallery/plugins/zoom";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import "../css/Gallery.css";

const API_URL = process.env.REACT_APP_APP_URL;
const STORAGE_URL = process.env.REACT_APP_STORAGE_URL;
const X_PLATFORM = process.env.REACT_APP_X_PLATFORM;
const API_KEY = process.env.REACT_APP_API_KEY;
const X_API_Version = process.env.REACT_APP_X_API_VERSION;

const GallerySection = () => {
  const { t, i18n } = useTranslation();
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const response = await axios.get(`${API_URL}/galleries`, {
          headers: {
            "X-Platform": X_PLATFORM,
            "API-Key": API_KEY,
            "X-API-Version": X_API_Version,
          },
          withCredentials: true,
        });

        if (response.data.success) {
          const formattedImages = response.data.data.map((item) => ({
            src: item.images
              ? `${STORAGE_URL}/${item.images}`
              : "/assets/placeholder.jpg",
            thumb: item.images
              ? `${STORAGE_URL}/${item.images}`
              : "/assets/placeholder.jpg",
            caption: item.title,
          }));
          setGalleryImages(formattedImages);
        } else {
          setError(t("galleryError"));
        }
      } catch (err) {
        setError(t("galleryError"));
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, [i18n.language]);

  return (
    <section id="gallery" className="gallery-container">
      <h2 className="gallery-title">{t("gallery")}</h2>
      <p className="gallery-description">{t("galleryDescription")}</p>

      {loading && (
        <div className="gallery-grid">
          {[...Array(6)].map((_, index) => (
            <div key={index} className="gallery-card shimmer">
              <div className="gallery-img shimmer-bg"></div>
              <div className="gallery-text shimmer-bg"></div>
            </div>
          ))}
        </div>
      )}

      {error && <p className="error-message">{error}</p>}

      {!loading && !error && (
        <LightGallery
          plugins={[lgZoom, lgThumbnail]}
          elementClassNames="gallery-grid"
        >
          {galleryImages.map((img, index) => (
            <a
              key={index}
              href={img.src}
              data-sub-html={img.caption}
              className="gallery-card"
            >
              <img src={img.thumb} alt={img.caption} className="gallery-img" />
              <div className="gallery-caption">{img.caption}</div>
            </a>
          ))}
        </LightGallery>
      )}
    </section>
  );
};

export default GallerySection;
